export default function Authentication() {
        return (
        <>
            <div className="login-container">
                <h2>Trwa werfikacja konta</h2>
                <p>Aby aktywować konto nalezy wybrać link podany w wiadomości</p>

            </div><footer className="footer">
                <p>&copy; 2024 Twoja Firma. Wszystkie prawa zastrzeżone.</p>
                <p><a href="privacy-policy.html">Polityka prywatności</a> | <a href="terms-of-service.html">Warunki użytkowania</a></p>
            </footer></>
    )
}